// extracted by mini-css-extract-plugin
export default {"rating":"KR-z","numberOfStars":"LR-z","count":"MR-z","barGraphSpacing":"NR-z","barGraph":"OR-z"};